import { Injectable, signal, computed, inject } from '@angular/core';
import { ToastService } from './toast.service';

export interface WishItem {
  slug: string;
  name: string;
  category: string;
  price: number;
  originalPrice: number;
  img: string;
}

@Injectable({ providedIn: 'root' })
export class WishlistService {
  private toast = inject(ToastService);
  private _items = signal<WishItem[]>([]);

  readonly items = this._items.asReadonly();
  readonly count = computed(() => this._items().length);

  has(slug: string): boolean {
    return this._items().some(i => i.slug === slug);
  }

  toggle(item: WishItem) {
    const had = this.has(item.slug);
    this._items.update(list =>
      had ? list.filter(i => i.slug !== item.slug) : [...list, item],
    );
    this.toast.show(had ? 'Removed from your wishlist.' : 'Product added to your wishlist.');
  }

  remove(slug: string) {
    this._items.update(list => list.filter(i => i.slug !== slug));
  }
}
